// extracted by mini-css-extract-plugin
module.exports = {"documentDetails":"DocumentDetailsTab__documentDetails___pdaOe"};